// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_bad5550d"};